import { Component, OnInit } from '@angular/core';
import { StoreService } from '../store.service';

@Component({
  selector: 'app-store-header-popup',
  templateUrl: './store-header-popup.component.html',
  styleUrls: ['./store-header-popup.component.css']
})
export class StoreHeaderPopupComponent implements OnInit {
  public isCartDropdownOpen: boolean = false;
  constructor(
    public ss: StoreService
  ) { }

  ngOnInit(): void {
  }

  showDropdown() {
    if (this.isCartDropdownOpen == true) {
      this.isCartDropdownOpen = false;
    }
    else {
      this.isCartDropdownOpen = true;
    }
  }
}
